import sortBy from "lodash/sortBy";
import { useTranslation } from "react-i18next";

import { MaterialGradeSchema, MaterialGradeType } from "shared";

export type MaterialGradeDetail = {
  materialGrade: MaterialGradeType;
  name: string;
};

export const useMaterialGradeDetails = (): {
  materialGradeDetails: MaterialGradeDetail[];
} => {
  const { t } = useTranslation();

  const materialGradeDetails = sortBy(
    Object.values(MaterialGradeSchema.Values).map((grade: MaterialGradeType) => ({
      materialGrade: grade,
      name: t(`qrl.materialGrades.${grade}`),
    })),
    (selectData) => selectData.name,
  );

  return { materialGradeDetails };
};
